function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}

export { formatMs };
